/**
 * Sending from a dashboard composer (or clicking a prompt chip): stash the
 * text as `pendingDraft` and open the side panel, where the panel chat sends
 * it as the first message of a new conversation in the agent's scope.
 */
import { useCallback } from "react";

import {
  agentPanelStore,
  type PanelAgent
} from "@/features/agents/agentPanelStore";
import type { AgentScope } from "@/features/agents/types";

export type DashboardDraft = {
  /** Hand the message to the side panel, which starts the conversation. */
  send: (text: string) => Promise<void>;
  isSending: boolean;
};

export const useDashboardDraft = (
  agent: PanelAgent,
  // The panel chat runs in the route's scope, which is this one.
  _scope: AgentScope
): DashboardDraft => {
  const send = useCallback(
    async (text: string) => {
      const trimmed = text.trim();
      if (!trimmed) return;
      agentPanelStore.setPendingDraft({ agent, text: trimmed });
      agentPanelStore.openWith({ agent });
    },
    [agent]
  );

  return { send, isSending: false };
};
